import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WebmasterSidebar from "../../components/WebmasterSidebar";
import { useAuth } from "../../context/AuthProvider";
import API_BASE_URL from "../../config/apiConfig";
import back from "../../assets/images/icon-back.svg";
import hide from "../../assets/images/hide.svg";
import show from "../../assets/images/show.svg";
import Swal from "sweetalert2";

const AddMedic: React.FC = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    password: "",
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  const validatePassword = (password: string): string | null => {
    if (password.length < 8) return "Parola trebuie să aibă cel puțin 8 caractere.";
    if (!/[A-Z]/.test(password)) return "Parola trebuie să conțină cel puțin o literă mare.";
    if (!/[a-z]/.test(password)) return "Parola trebuie să conțină cel puțin o literă mică.";
    if (!/\d/.test(password)) return "Parola trebuie să conțină cel puțin un număr.";
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return "Parola trebuie să conțină cel puțin un caracter special.";
    return null;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const passwordError = validatePassword(formData.password);
    if (passwordError) {
      Swal.fire({
        icon: "error",
        title: passwordError,
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    const payload = {
      username: formData.username,
      email: formData.email,
      firstname: formData.firstName,
      lastname: formData.lastName,
      phone: formData.phone,
      password: formData.password,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/users/add-medic`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const { detail } = await response.json();
        throw new Error(detail || "A apărut o eroare.");
      }

      Swal.fire({
        icon: "success",
        title: "Medic adăugat cu succes!",
        toast: true,
        position: "top-end",
        timer: 2500,
        showConfirmButton: false,
      });

      setTimeout(() => navigate("/webmaster/medics"), 2000);
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Eroare",
        text: err.message || "A apărut o eroare.",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  return (
    <div className={`dashboard-container ${isCollapsed ? "collapsed" : ""}`}>
      <WebmasterSidebar onCollapseChange={(collapsed) => setIsCollapsed(collapsed)} />

      <div className="page-content">
        <h1 className="page-title">Adaugă Medic</h1>
        <div className="table-top">
          <div className="page-return">
            <button className="button-return" onClick={() => navigate(-1)}>
              <img src={back} alt="Înapoi" className="back-icon" /> Înapoi
            </button>
          </div>
        </div>
        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <label>Username:</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Username"
                required
              />
            </div>
            <div className="form-row">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Adresa de e-mail"
                required
              />
            </div>
            <div className="form-row">
              <label>Nume:</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Numele"
                required
              />
            </div>
            <div className="form-row">
              <label>Prenume:</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Prenumele"
                required
              />
            </div>
            <div className="form-row">
              <label>Telefon:</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Telefon (opțional)"
              />
            </div>
            <div className="form-row password-field">
              <label>Parolă:</label>
              <input
                type={isPasswordVisible ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Parola"
                required
              />
              <button
                type="button"
                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
              >
                {isPasswordVisible ? (
                  <img className="hide-password" src={hide} alt="Ascunde" />
                ) : (
                  <img className="show-password" src={show} alt="Arată" />
                )}
              </button>
            </div>
            <div className="form-row form-actions">
              <button
                className="cancel-btn"
                onClick={() => navigate(-1)}
                type="button"
              >
                Anulează
              </button>
              <button className="primary-btn" type="submit">
                Adaugă
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddMedic;
